import { render, staticRenderFns } from "./findpwd.vue?vue&type=template&id=4ab35b20&scoped=true"
import script from "./findpwd.vue?vue&type=script&lang=js"
export * from "./findpwd.vue?vue&type=script&lang=js"
import style0 from "./findpwd.vue?vue&type=style&index=0&id=4ab35b20&prod&lang=scss&scoped=true"
import style1 from "./findpwd.vue?vue&type=style&index=1&id=4ab35b20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab35b20",
  null
  
)

export default component.exports